// extracted by mini-css-extract-plugin
export var addButton = "_ed-0";
export var border = "_ed-8";
export var check = "_ed-h";
export var danger = "_ed-6";
export var dropdownContainer = "_ed-1";
export var editModalBody = "_ed-j";
export var footerContainer = "_ed-i";
export var fullWidth = "_ed-a";
export var hide = "_ed-9";
export var icon = "_ed-3";
export var input = "_ed-7";
export var inputFlex = "_ed-b";
export var inputWrapper = "_ed-c";
export var manualFocus = "_ed-5";
export var optionButton = "_ed-4";
export var pillWrapper = "_ed-e";
export var pointer = "_ed-2";
export var showOverflow = "_ed-f";
export var tagsFlex = "_ed-d";
export var xButton = "_ed-g";